import { Text, TextProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export const TextBubble = (textProps: PropsWithChildren<TextProps>) => (
  <Text
    as="span"
    display="inline-block"
    background="white"
    textColor="blue"
    fontSize="xs"
    lineHeight="short"
    fontWeight="medium"
    borderWidth="1px"
    borderColor="currentColor"
    rounded="full"
    pl="space.6"
    pr="space.8"
    {...textProps}
  />
);
